module.exports = __webpack_public_path__ + "img/grafic.26520a81.png";